<template>
    <default-modal
        :show="showModal"
        :height="0"
        :closeOnClickModal="false"
        @close="closeModal"
    >
        <el-form :model="form" ref="form">
            <list-email
                ref="list-email"
                :emailList="emails"
                @on-add-email="emails.push($event)"
                @remove-email-from-list="removeEmailFromList"
            ></list-email>
        </el-form>
        <div class="modal-action-button-container">
            <el-button
                class="delete-event-cancel-btn"
                type="text"
                small
                :loading="loading"
                @click="closeModal"
            >Cancel</el-button>
            <el-button
                class="gcmcn-primary-btn small validate-btn delete-event-confirm-btn"
                :loading="loading"
                @click="sendEmail"
            >Resend emails</el-button>
        </div>
    </default-modal>

</template>

<script>
import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
import ListEmail from '../../partials/ListEmailValidatorVue';
export default {

    components: {
        ListEmail,
        DefaultModal,
    },

    props: {

    },

    data (){
        return {
            form: {},
            showModal: false,
            loading: false,
            feed: null,
            emails: [],
        };
    },

    computed: {
    },

    mounted (){
    },

    methods: {
        open (feed){
            this.$set(this, 'feed', feed);
            this.$set(this, 'emails', feed.source_emails.constructor === Object ? [] : feed.source_emails);
            this.showModal = true;
        },
        closeModal (){
            this.showModal = false;
            this.$set(this, 'feed', null);
        },
        removeEmailFromList (email){
            let index = this.emails.indexOf(email);
            if(index > -1){
                this.emails.splice(index, 1);
            }
        },

        sendEmail (){
            if(this.$refs['list-email'].validateAllEmails()){
                this.loading = true;
                this.$store.dispatch('createItem', {
                    item: {
                        action: 'SEND_EXTERNAL_SOURCE_NOTIF',
                        feed_uid: this.feed.uid,
                        status: 'PENDING',
                        context: { emails: this.emails }
                    },
                    model: 'feedModificationRequests',
                    url: this.$store.state.api.meta.listModels.feedModificationRequests.url
                }).then((res) => {
                    this.$emit('watch-feed-modification-request', res.url);
                    this.showModal = false;
                }).finally(() => {
                    this.loading = false;
                });
            }
        }

    },
};
</script>

<style lang="scss">
.modal-confirm-feed{
}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/modal-send-email.vue